import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "label-below-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M21.5 6.25018C21.5 4.17912 19.8211 2.50018 17.75 2.50018L5.75 2.50018C3.67893 2.50018 2 4.17912 2 6.25018L2 14.2502C2 16.3213 3.67893 18.0002 5.75 18.0002L17.75 18.0002C19.8211 18.0002 21.5 16.3213 21.5 14.2502L21.5 6.25018ZM17.75 4.00018C18.9926 4.00018 20 5.00754 20 6.25018L20 14.2502C20 15.4928 18.9926 16.5002 17.75 16.5002L5.75 16.5002C4.50736 16.5002 3.5 15.4928 3.5 14.2502L3.5 6.25018C3.5 5.00754 4.50736 4.00018 5.75 4.00018L17.75 4.00018Z"
    }, null, -1),
    _createElementVNode("path", { d: "M2.75 20C2.33579 20 2 20.3358 2 20.75C2 21.1642 2.33579 21.5 2.75 21.5L20.75 21.5C21.1642 21.5 21.5 21.1642 21.5 20.75C21.5 20.3358 21.1642 20 20.75 20L2.75 20Z" }, null, -1)
  ])))
}
export default { render: render }